import apiClient from "../common/apiClient";
import { useEffect, useState } from "react";
import AppConfig from "../common/AppConfig";
import "./forms.scss";
import PatientInfo1 from "./PatientInfo1";
import TTCheckMeasurement from "../pages/patientMeasurement/TTCheckMeasurement";
import FoamCarving from "./FoamCarving";
import Submit from "../pages/submit/Submit";
import TfMeasurement from "../pages/patientMeasurement/TfMeasurement";
import BilateralStepper from "../components/stepper/BilateralStepper";
import { OrderTickIcon } from "../icons/svg";
import TtMeasurement from "../pages/patientMeasurement/TtMeasurement";
import TFDefinitiveMeasurement from "../pages/patientMeasurement/TFDefinitiveMeasurement";
import TTOneMeasure from "../pages/patientMeasurement/TTOneMeasure";
import TFOneSocketMeasure from "../pages/patientMeasurement/TFOneSocketMeasure";
import ClinicInfo from "./ClinicInfo";
import PatientInfo2 from "./PatientInfo2";
import BilateralOrderReview from "./BilateralOrderReview";
import MultipleDesignerLinerSelection from "../steps/MultipleDesignerLinerSelection"
import DesignerLinerFormTypeSelection from "./DesignerLinerFormTypeSelection";
import DesignerLinerProxy from "./DesignerLinerProxy";
import AccountNumberPage from "./AccountNumberPage";

const Bilateral = ({ url, split, formId }) => {
  const [open, setOpen] = useState(false);
  const [showSubmit, setShowSubmit] = useState(true);
  const [activeInnerStep, setActiveInnerStep] = useState(0);
  const [activeOuterStep, setActiveOuterStep] = useState(0);
  const [defaultComponent, setDefaultComponent] = useState();
  const [currentComponent, setCurrentComponent] = useState();
  const [currentFormIndex, setCurrentFormIndex] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isBack, setIsBack] = useState(false);
  const [designLinerInnerSteps, setDesignLinerInnerSteps] = useState([]);
  const [tempCart, setTempCart] = useState(Array(0));
  const [init, setInit] = useState(true);
  const [cart, setCart] = useState(Array(0));
  const [tempArray, setTempArray] = useState([]);

  let currentIndex = 0;

  const loadCart = (skipFormSteps = false) => {
    if (!skipFormSteps) {
      getFormSteps()
    }

    Promise.all([apiClient.get("cart/" + formId + '?formIndex=0'),
    apiClient.get("cart/" + formId + '?formIndex=1')]
    ).then(response => {
      let combined = response[0].data.concat(response[1].data);
      setCart(combined);
    }).catch(error => {
      console.log(error)
    });
  }

  useEffect(() => {
    tempArray.push(
      elements?.find(
        (item) => item.url === url.replace(AppConfig.orderFormPath, "")
      )
    );
    if (url.includes("designliners")) {
      tempArray.push(createNewDesignLinerHeader())
    }
    else {
      tempArray.push(elements?.find((item) => item.id === split));
    }
    tempArray.push(userInformation);
    setTempArray(tempArray)

    setDefaultComponent([...tempArray]);
    setCurrentComponent(tempArray[0]);
  }, [url, split]);

  useEffect(() => {
    if (isCompleted) {
      setActiveOuterStep(0);
      let tempComponent = defaultComponent[currentFormIndex + 1];
      if (tempComponent?.id === formId) {
        tempComponent.formData[tempComponent.formData.findIndex(fd => fd.id === 1)] = createDesignerLinerProxy(false);
      }
      setCurrentComponent(tempComponent);
      setCurrentFormIndex(currentFormIndex + 1);
      setIsCompleted(false);
    } else if (isBack && currentFormIndex > 0) {
      let tempComponent = defaultComponent[currentFormIndex - 1];
      setCurrentComponent(tempComponent);
      setActiveOuterStep(
        tempComponent.formData?.length - 1
      );
      setCurrentFormIndex(currentFormIndex - 1);
      setIsBack(false);
    }
  }, [isCompleted, isBack, currentFormIndex, defaultComponent]);

  const handleNext = (step, orderIndex) => {
    if (step === tempArray[orderIndex]?.formData?.length) {
      currentIndex = orderIndex + 1;
      setIsCompleted(true);
    } else {
      setActiveOuterStep(step);
      setActiveInnerStep(0);
    }
  };

  const joinedCart = () => {
    let uniqueMainCart = cart.filter(c => !tempCart.some(t => t.sourceId?.toLowerCase() === c.sourceId?.toLowerCase() || t.name === c.name));

    return uniqueMainCart.concat(tempCart);
  }

  const navigateAway = (outerStep, innerStep, formIndex) => {
    setActiveOuterStep(outerStep);
    setActiveInnerStep(innerStep);
    const tempComponent = tempArray[outerStep]
    setCurrentComponent(tempComponent);
    setCurrentFormIndex(formIndex)
  }

  const handleBack = (step, formIndex) => {
    if (formIndex === 1) {
      let tempComponent = tempArray[formIndex];
      tempComponent.formData[tempComponent.formData.findIndex(fd => fd.id === 1)] = createDesignerLinerProxy(true);
      setCurrentComponent(tempComponent);
    }
    if (step === 0) {
      if (currentIndex > 0) {
        currentIndex = currentIndex - 1;
        setIsBack(true);
      }
      return;
    } else {
      setActiveOuterStep(step - 1);
      setActiveInnerStep(0);
    }
  };

  const handleClearBack = () => {
    setActiveOuterStep(0);
    setActiveInnerStep(0);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShowSubmit(true);
  };

  const getFormSteps = (inactiveSteps = []) => {
    const formSteps = [
      { id: 2, name: "Shape Creation", isActive: true },
      { id: 12, name: "Patient Information", isActive: true },
      { id: 3, name: "Measurements", isActive: true },
      { id: 4, name: "Liner Type", isActive: true },
      { id: 5, name: "Interface Material", isActive: true },
      { id: 6, name: "Fabric", isActive: true },
      { id: 7, name: "Fabric Color", isActive: true },
      { id: 8, name: "Liner Design", isActive: true },
      { id: 9, name: "Quantity", isActive: true },
      { id: 10, name: "Request Design Technician", isActive: true },
      { id: 11, name: "Notes", isActive: true },
    ];

    const activeFormSteps = formSteps.filter(fs => {
      if (!inactiveSteps.includes(fs.id)) {
        return fs;
      }
    })

    setDesignLinerInnerSteps(activeFormSteps);
  }

  const setActiveInnerStepById = (id) => {
    const formSteps = designLinerInnerSteps;
    const innerStepIndex = formSteps.indexOf(formSteps.find(i => i.id === id));
    setActiveInnerStep(innerStepIndex);
  }

  const createNewDesignLinerHeader = () => {
    return ({
      id: "23",
      url: "/designliners",
      formData: [
        createDesignerLinerProxy(),
        createNewDesignLiner(),
      ],
      name: "Design Liner",
      bilateralTabName: "(Right)",
    })
  }

  const createDesignerLinerProxy = (isBack = false) => {
    return {
      id: 1,
      name: "Design Liner (Right)",
      innerSteps: [],
      formContent: (
        <DesignerLinerProxy
          formIndex={1}
          currentIndex={1}
          formTypeId={23}
          isBack={isBack}
          orderIndex={1}
          handleNext={handleNext}
          handleBack={handleBack}
          setActiveOuterStep={setActiveOuterStep}
        />
      ),
    }
  }

  const createNewDesignLiner = () => {
    return {
      id: 4,
      name: "Product Information",
      innerSteps: [],
      formContent: (
        <MultipleDesignerLinerSelection
          setActiveInnerStep={setActiveInnerStepById}
          getFormSteps={getFormSteps}
          innerStep={activeInnerStep}
          formTypeId={23}
          currentIndex={2}
          setIsBack={setIsBack}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          handleClearBack={handleClearBack}
          formIndex={1}
          isBilateral={true}
          setTempCart={setTempCart}
          loadCart={loadCart}
          orderIndex={1}
          setActiveOuterStep={setActiveOuterStep}
        />
      )
    }
  }

  const userInformation = {
    name: "Order Information",
    formData: [
      {
        id: 4,
        name: "Customer information",
        innerSteps: [],
        formContent: (
          <ClinicInfo
            formTypeId={formId}
            currentIndex={1}
            setIsBack={setIsBack}
            handleNext={handleNext}
            handleBack={handleBack}
            handleClearBack={handleClearBack}
            orderIndex={2}
            isBilateral={true}
          />
        ),
      },

      {
        id: 5,
        name: "Shipping Information",
        innerSteps: [],
        formContent: (
          <PatientInfo2
            formTypeId={formId}
            currentIndex={2}
            handleNext={handleNext}
            handleBack={handleBack}
            handleClearBack={handleClearBack}
            orderIndex={2}
            isBilateral={true}
          />
        ),
      },

      {
        id: 6,
        name: "Order Review",
        innerSteps: [],
        formContent: (
          <BilateralOrderReview
            forms={tempArray}
            handleNext={handleNext}
            handleBack={handleBack}
            handleClearBack={handleClearBack}
            currentIndex={3}
            orderIndex={2}
            isBilateral={true}
          />
        ),
      },

      {
        id: 7,
        name: "Submit",
        innerSteps: [],
        formContent: <Submit />,
      },
    ],
  };

  const elements = [
    {
      id: "3",
      url: "/ttchecksocket",
      formData: [
        {
          id: 1,
          name: "Patient Information",
          innerSteps: [
            { id: 1, name: "Patient Info", isActive: true },
            { id: 2, name: "Amputation Level", isActive: true },
            { id: 3, name: "Amputation Side", isActive: true },
            { id: 4, name: "K Level", isActive: true },
          ],
          formContent: (
            <PatientInfo1
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={3}
              setIsBack={setIsBack}
              currentIndex={1}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },

        {
          id: 2,
          name: "Socket Design Specifications",
          innerSteps: [
            { id: 1, name: "Shape Creation", isActive: true },
            { id: 2, name: "Socket Style", isActive: false },
            { id: 3, name: "Trimline", isActive: true },
            { id: 4, name: "Modification", isActive: true },
            { id: 5, name: "Angles", isActive: true },
            { id: 6, name: "Measurement Notes", isActive: true },
          ],
          formContent: (
            <TTCheckMeasurement
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={3}
              currentIndex={2}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },

        {
          id: 3,
          name: "Product Information",
          innerSteps: [
            { id: 1, name: "Foam Carving", isActive: true },
            { id: 2, name: "Socket Material", isActive: true },
            { id: 3, name: "Suspension", isActive: true },
            { id: 4, name: "Mounting Plate", isActive: true },
            { id: 5, name: "Insert Material", isActive: true },
            { id: 6, name: "Delivery Date", isActive: true },
            { id: 7, name: "Notes", isActive: true },
          ],
          formContent: (
            <FoamCarving
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={3}
              currentIndex={3}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },
      ],
      name: "TT Check Socket",
    },

    {
      id: "4",
      url: "/tfchecksocket",
      formData: [
        {
          id: 1,
          name: "Patient Information",
          innerSteps: [
            { id: 1, name: "Patient Info", isActive: true },
            { id: 2, name: "Amputation Level", isActive: true },
            { id: 3, name: "Amputation Side", isActive: true },
            { id: 4, name: "K Level", isActive: true },
          ],
          formContent: (
            <PatientInfo1
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={4}
              currentIndex={1}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },

        {
          id: 2,
          name: "Socket Design Specifications",
          innerSteps: [
            { id: 1, name: "Shape Creation", isActive: true },
            { id: 2, name: "Brim", isActive: true },
            { id: 4, name: "Modification", isActive: true },
            { id: 5, name: "Angles", isActive: true },
            { id: 6, name: "Measurement Notes", isActive: true },
          ],
          formContent: (
            <TfMeasurement
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={4}
              currentIndex={2}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },

        {
          id: 3,
          name: "Product Information",
          innerSteps: [
            { id: 1, name: "Foam Carving", isActive: true },
            { id: 2, name: "Socket Material", isActive: true },
            { id: 3, name: "Suspension", isActive: true },
            { id: 4, name: "Mounting Plate", isActive: true },
            { id: 5, name: "Insert Material", isActive: true },
            { id: 6, name: "Delivery Date", isActive: true },
            { id: 7, name: "Notes", isActive: true },
          ],
          formContent: (
            <FoamCarving
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={4}
              currentIndex={3}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },
      ],
      name: "TF Check Socket",
    },

    {
      id: "5",
      url: "/ttdefinitive",
      formData: [
        {
          id: 1,
          name: "Patient Information",

          innerSteps: [
            { id: 1, name: "Patient Info", isActive: true },
            { id: 2, name: "Amputation Level", isActive: true },
            { id: 3, name: "Amputation Side", isActive: true },
            { id: 4, name: "K Level", isActive: true },
          ],
          formContent: (
            <PatientInfo1
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={5}
              currentIndex={1}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },

        {
          id: 2,
          name: "Product Information",
          innerSteps: [
            { id: 1, name: "Socket Options", isActive: true },
            { id: 2, name: "Measurements", isActive: true },
            { id: 3, name: "Socket Material", isActive: true },
            { id: 4, name: "Insert Material", isActive: true },
            { id: 5, name: "RevoFit", isActive: true },
            { id: 6, name: "Suspension", isActive: true },
            { id: 7, name: "Mounting Plates", isActive: true },
            { id: 8, name: "Prosthetic Height Adjustment", isActive: true },
            { id: 9, name: "Delivery Date", isActive: true },
            { id: 10, name: "Notes", isActive: true },
          ],
          formContent: (
            <TtMeasurement
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={5}
              currentIndex={2}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },
      ],
      name: "TT Definitive Socket",
    },

    {
      id: "6",
      url: "/tfdefinitive",
      formData: [
        {
          id: 1,
          name: "Patient Information",
          innerSteps: [
            { id: 1, name: "Patient Info", isActive: true },
            { id: 2, name: "Amputation Level", isActive: true },
            { id: 3, name: "Amputation Side", isActive: true },
            { id: 4, name: "K Level", isActive: true },
          ],
          formContent: (
            <PatientInfo1
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={6}
              currentIndex={1}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },

        {
          id: 2,
          name: "Product Information",
          innerSteps: [
            { id: 1, name: "Socket Options", isActive: true },
            { id: 2, name: "Measurements", isActive: true },
            { id: 3, name: "Socket Material", isActive: true },
            { id: 4, name: "Insert Material", isActive: true },
            { id: 5, name: "RevoFit", isActive: true },
            { id: 6, name: "Suspension", isActive: true },
            { id: 7, name: "Mounting Plates", isActive: true },
            { id: 8, name: "Prosthetic Height Adjustment", isActive: true },
            { id: 9, name: "Delivery Date", isActive: true },
            { id: 10, name: "Notes", isActive: true },
          ],
          formContent: (
            <TFDefinitiveMeasurement
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={6}
              currentIndex={2}
              setIsBack={setIsBack}
              handleNext={handleNext}
              handleBack={handleBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },
      ],
      name: "TF Definitive Socket",
    },
    {
      id: "23",
      url: "/designliners",
      formData: [
        {
          id: 1,
          name: "Form Type Selection",
          innerSteps: [],
          formContent: (
            <DesignerLinerFormTypeSelection
              setActiveInnerStep={setActiveInnerStep}
              currentIndex={localStorage.getItem("internalAccount") ? 2 : 1}
              formTypeId={23}
              setIsBack={setIsBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
              handleNext={handleNext}
              formIndex={currentFormIndex}
              isBilateral={true}
              orderIndex={0}
              handleBack={handleBack}
              disableBackButton={localStorage.getItem("internalAccount") === null}
              getFormSteps={getFormSteps}
              innerStep={activeInnerStep}
              setTempCart={setTempCart}
              loadCart={loadCart}
              setActiveOuterStep={setActiveOuterStep}
            />
          ),
        },
        {
          id: 4,
          name: "Product Information",
          innerSteps: [],
          formContent: (
            <MultipleDesignerLinerSelection
              setActiveInnerStep={setActiveInnerStepById}
              getFormSteps={getFormSteps}
              innerStep={activeInnerStep}
              formTypeId={23}
              currentIndex={localStorage.getItem("internalAccount") ? 3 : 2}
              orderIndex={0}
              setIsBack={setIsBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
              handleNext={handleNext}
              handleBack={handleBack}
              formIndex={currentFormIndex}
              isBilateral={true}
              setTempCart={setTempCart}
              loadCart={loadCart}
              setActiveOuterStep={setActiveOuterStep}
            />
          ),
        },
      ],
      name: "Design Liner",
      bilateralTabName: "(Left)",
    },
    {
      id: "8",
      url: "/tfonesocket",
      formData: [
        {
          id: 1,
          name: "Patient Information",
          innerSteps: [
            { id: 1, name: "Patient Info", isActive: true },
            { id: 2, name: "Amputation Level", isActive: true },
            { id: 3, name: "Amputation Side", isActive: true },
            { id: 4, name: "K Level", isActive: true },
          ],
          formContent: (
            <PatientInfo1
              setActiveInnerStep={setActiveInnerStep}
              currentIndex={1}
              formTypeId={8}
              setIsBack={setIsBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },

        {
          id: "7",
          url: "/ttonesocket",
          formData: [
            {
              id: 1,
              name: "Patient Information",
              innerSteps: [
                { id: 1, name: "Patient Info", isActive: true },
                { id: 2, name: "Amputation Level", isActive: true },
                { id: 3, name: "Amputation Side", isActive: true },
                { id: 4, name: "K Level", isActive: true },
              ],
              formContent: (
                <PatientInfo1
                  setActiveInnerStep={setActiveInnerStep}
                  formTypeId={7}
                  currentIndex={1}
                  setIsBack={setIsBack}
                  handleNext={handleNext}
                  handleBack={handleBack}
                  handleClickOpen={handleClickOpen}
                  handleClose={handleClose}
                  showSubmit={showSubmit}
                  setShowSubmit={setShowSubmit}
                  open={open}
                  handleClearBack={handleClearBack}
                />
              ),
            },

            {
              id: 2,
              name: "Product Measurement",
              innerSteps: [
                { id: 1, name: "Measurements", isActive: true },
                { id: 2, name: "One® System", isActive: true },
                { id: 3, name: "Socket Finish", isActive: true },
                { id: 4, name: "Socket Options", isActive: true },
                { id: 5, name: "Mounting Plate", isActive: true },
                { id: 6, name: "Prosthetic Height Adjustment", isActive: true },
                { id: 7, name: "Delivery Date", isActive: true },
                { id: 7, name: "Notes", isActive: true },
              ],
              formContent: (
                <TTOneMeasure
                  setActiveInnerStep={setActiveInnerStep}
                  formTypeId={7}
                  currentIndex={2}
                  setIsBack={setIsBack}
                  handleNext={handleNext}
                  handleBack={handleBack}
                  handleClickOpen={handleClickOpen}
                  handleClose={handleClose}
                  showSubmit={showSubmit}
                  setShowSubmit={setShowSubmit}
                  open={open}
                  handleClearBack={handleClearBack}
                />
              ),
            },
          ],
          name: "TT One® Socket",
        },
        {
          id: 2,
          name: "Product Information",
          innerSteps: [
            { id: 1, name: "Measurements", isActive: true },
            { id: 2, name: "One® System", isActive: true },
            { id: 3, name: "Socket Finish", isActive: true },
            { id: 4, name: "Mounting Plate", isActive: true },
            { id: 5, name: "Prosthetic Height Adjustment", isActive: true },
            { id: 6, name: "Delivery Date", isActive: true },
            { id: 7, name: "Notes", isActive: true },
          ],
          formContent: (
            <TFOneSocketMeasure
              setActiveInnerStep={setActiveInnerStep}
              formTypeId={8}
              currentIndex={2}
              handleNext={handleNext}
              handleBack={handleBack}
              setIsBack={setIsBack}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              showSubmit={showSubmit}
              setShowSubmit={setShowSubmit}
              open={open}
              handleClearBack={handleClearBack}
            />
          ),
        },
      ],
      name: "TF One® Socket",
    },
  ];

  if (localStorage.getItem("internalAccount")) {
    elements.find(e => e.id === "23").formData.unshift({
      id: 0,
      name: "Account Number",
      formContent: (
        <AccountNumberPage
          setActiveInnerStep={setActiveInnerStep}
          formTypeId={23}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          loadCart={loadCart}
          handleClearBack={handleClearBack}
          currentIndex={1}
          orderIndex={0}
          setIsBack={setIsBack}
          formIndex={currentFormIndex}
          isBilateral={true}
          disableBackButton={localStorage.getItem("internalAccount") === null}
          getFormSteps={getFormSteps}
          innerStep={activeInnerStep}
          setActiveOuterStep={setActiveOuterStep}
        />
      )
    })
  }

  const totalIds = currentComponent?.formData.reduce((count) => {
    return count + 1;
  }, 0);

  useEffect(() => {
    if (init) {
      loadCart();
      setInit(false);
    }
  }, [])

  return (
    <div className="bilateral">
      <div style={{ display: "flex", gap: "4px", marginBottom: "2px" }}>
        {defaultComponent?.map((item, index) => (
          <div role={index === 0 ? "button" : ""} onClick={() => index === 0 ? navigateAway(0, 0, 0) : null}
            style={{ width: "100%", height: "56px" }} key={index}>
            <div
              className={`${currentFormIndex > index ? "biletralCompletion" : ""
                } bilateralHeader`}
              style={{
                background:
                  currentFormIndex === 2 &&
                    currentComponent.formData.length === activeOuterStep + 1
                    ? "var(--secondary-600)"
                    : currentFormIndex > index
                      ? "var(--secondary-600)"
                      : currentFormIndex === index
                        ? "white"
                        : "#F3F3F3",
                color:
                  currentFormIndex === 2 &&
                    currentComponent.formData.length === activeOuterStep + 1
                    ? "white"
                    : currentFormIndex > index
                      ? "white"
                      : "",
              }}
            >
              {currentFormIndex > index ? (
                <div className="tickIcon">
                  <OrderTickIcon />
                </div>
              ) : (
                <></>
              )}
              {currentFormIndex === 2 && index === 2 &&
                currentComponent?.formData?.length === activeOuterStep + 1 && (
                  <div className="tickIcon">
                    <OrderTickIcon />
                  </div>
                )}
                {index !== 2 ? item?.name + " " + item?.bilateralTabName : item?.name}
            </div>
          </div>
        ))}
      </div>

      {currentComponent && (
        <BilateralStepper
          data={currentComponent.formData}
          innerStep={activeInnerStep}
          activeOuterStep={activeOuterStep}
          formName={currentComponent.name}
          totalSteps={totalIds}
          cart={joinedCart()}
        />
      )}
    </div>
  );
};

export default Bilateral;